import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { HttpRequestsService } from 'src/app/services/http-requests.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-activity-dialog',
  templateUrl: './activity-dialog.component.html',
  styleUrls: ['./activity-dialog.component.scss']
})
export class ActivityDialogComponent implements OnInit {
  @Input("edit") edit: boolean = true;
  public edited: boolean = false;
  public allowed: boolean;
  public city = history.state.city;
  public description: any;

  constructor(private keycloak: KeycloakService, private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any, private router: Router, private req: HttpRequestsService<any>, public dialog: MatDialog ) { }

  ngOnInit(): void {
    this.data.summary = this.data.summary.replace(/<[^>]*>/g, '');
    this.dialogRef.updateSize('100%');

    if (this.keycloak.getUserRoles().includes('MODERATOR')) {
      this.allowed = true;
    } else {
      const keycloakInstance = this.keycloak.getKeycloakInstance();
      if (keycloakInstance.authenticated) {
        this.keycloak.loadUserProfile().then(profile => {
          if (profile['attributes'].City[0] == this.city) {
            this.allowed = true;
          } else {
            this.allowed = false;
          };
        });
      } else {
        this.allowed = false;
      }
    }
  }

  onCity(city) {
    this.dialogRef.close({ data: false });
    this.req.getCities().subscribe((res) => {
      res.forEach(e => {
        if(city == e.City ){
          this.description = e.Description;
          this.router.navigateByUrl(`Cities/${city}`, { state: { city: city, description: this.description} });
        }
      });
    });
  }

  onFocus() {
    this.edited = true;
  }

  onChange(element) {
    this.data.summary = element;
  }

  onUpdate(id, data) {
    this.req.updateContent(id, data).subscribe(res => {})

    if(this.edited){
      Swal.fire(
        'Done!',
        'Activity updated!',
        'success'
      )
    }
    this.dialogRef.close({ data: false });
  }

  onDelete() {
    this.req.deleteContent(this.data.id).subscribe((res) =>
      Swal.fire(
        'Content deleted!',
        '',
        'success'
      )
    );
    this.dialogRef.close({ data: false });
  }
}